import React from 'react';

import { css } from '@emotion/react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Skeleton } from '@mui/material';

import { titleStyle } from '@styles/common';

/** 조합 관리 > 상세 > 포트폴리오 상세 > 상단 스켈레톤 */
const PortfolioHeaderSkeleton = () => {
  return (
    <>
      <div
        css={[
          titleStyle,
          {
            padding: '0 40px',
            justifyContent: 'space-between',
            marginBottom: '20px',
          },
        ]}
      >
        <div css={portfolioName}>
          <Skeleton variant="text" width={80} />
          <div css={portfolioLink}>
            <OpenInNewIcon color="disabled" fontSize="small" />
          </div>
        </div>
        <Skeleton
          variant="rectangular"
          width={88}
          height={34}
          sx={{ borderRadius: '5px' }}
        />
      </div>
    </>
  );
};

export default PortfolioHeaderSkeleton;

const portfolioName = css`
  display: flex;
  gap: 10px;
`;

const portfolioLink = css`
  display: flex;
  align-items: center;
`;
